import { Table } from 'react-bootstrap'

import ActionButtonProvider from '../../../../components/action_button/ActionButtonContext'
import LoadingSpinner from '../../../../components/LoadingSpinner'
import {
  STORE_RELATIONS_LOADING_TEXT,
  STORE_RELATIONS_NO_RESULTS_TEXT,
  STORE_RELATIONS_TABLE_COLUMNS
} from '../../constants/storeConstants'
import { getStoreRelationModelKey } from '../../utils/storeRelationDisplayUtils'
import StoreRelationsRow from './StoreRelationsRow'

const StoreRelationsTable = ({
  data = [],
  loading = false,
  onShowDetails,
  onAssignPrincipal,
  onReassignPrincipal,
  onSuspend,
  onEdit,
  onReactivate
}) => {
  const resolveRowKey = (model, index) => {
    return getStoreRelationModelKey(model, index)
  }

  return (
    <Table hover responsive className="oc-fixed-table">
      <thead className="table-header-gray-poc">
        <tr>
          {STORE_RELATIONS_TABLE_COLUMNS.map((column) => (
            <th key={column.key} className={column.className}>
              {column.label}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {loading ? (
          <tr>
            <td colSpan={7} className="store-relations-loading-cell">
              <div
                className="store-relations-loading-wrap"
              >
                <div className="loading-card store-relations-loading-card">
                  <LoadingSpinner text={STORE_RELATIONS_LOADING_TEXT} />
                </div>
              </div>
            </td>
          </tr>
        ) : !data || data.length === 0 ? (
          <tr>
            <td colSpan={STORE_RELATIONS_TABLE_COLUMNS.length}>{STORE_RELATIONS_NO_RESULTS_TEXT}</td>
          </tr>
        ) : (
          <ActionButtonProvider>
            {data.map((model, index) => (
              <StoreRelationsRow
                key={resolveRowKey(model, index)}
                model={model}
                onShowDetails={onShowDetails}
                onAssignPrincipal={onAssignPrincipal}
                onReassignPrincipal={onReassignPrincipal}
                onSuspend={onSuspend}
                onEdit={onEdit}
                onReactivate={onReactivate}
              />
            ))}
          </ActionButtonProvider>
        )}
      </tbody>
    </Table>
  )
}

export default StoreRelationsTable
